// assets
import { IconDashboard, IconUser, IconBuildingStore, IconDatabase } from '@tabler/icons';

// constant
const icons = { IconDashboard, IconUser, IconBuildingStore, IconDatabase };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const dashboard = {
    id: 'dashboard',
    title: 'MENU UTAMA',
    type: 'group',
    children: [
        {
            id: 'dashboard',
            title: 'Dashboard',
            type: 'item',
            url: '/admin/dashboard',
            icon: icons.IconDashboard,
            breadcrumbs: false,
            allowedPermission: ['super', 'admin']
        },
        {
            id: 'manage-admin',
            title: 'Admin Management',
            type: 'item',
            url: '/admin/manage-admin',
            icon: icons.IconUser,
            breadcrumbs: false,
            allowedPermission: ['super']
        },
        {
            id: 'orders',
            title: 'Order Management',
            type: 'item',
            url: '/admin/orders',
            icon: icons.IconBuildingStore,
            breadcrumbs: true,
            allowedPermission: ['super', 'admin', 'admin-group']
        },
        {
            id: 'master-data',
            title: 'Master Data',
            type: 'collapse',
            icon: icons.IconDatabase,
            allowedPermission: ['super', 'admin-group'],
            children: [
                {
                    id: 'optik-group',
                    title: 'Optik Parent',
                    type: 'item',
                    url: '/admin/master-data/optik-group',
                    icon: icons.IconDatabase,
                    breadcrumbs: false,
                    allowedPermission: ['super']
                },
                {
                    id: 'optik',
                    title: 'Optik',
                    type: 'item',
                    url: '/admin/master-data/optik',
                    icon: icons.IconDatabase,
                    breadcrumbs: false,
                    allowedPermission: ['super', 'admin-group']
                },
                {
                    id: 'account-optik',
                    title: 'Account Optik',
                    type: 'item',
                    url: '/admin/master-data/account-optik',
                    icon: icons.IconDatabase,
                    breadcrumbs: false,
                    allowedPermission: ['super', 'admin-group']
                },
                {
                    id: 'coating',
                    title: 'Coating',
                    type: 'item',
                    url: '/admin/master-data/coating',
                    icon: icons.IconDatabase,
                    breadcrumbs: false,
                    allowedPermission: ['super']
                },
                {
                    id: 'tinting-density',
                    title: 'Tinting Density',
                    type: 'item',
                    url: '/admin/master-data/tinting-density',
                    icon: icons.IconDatabase,
                    breadcrumbs: false,
                    allowedPermission: ['super']
                },
                {
                    id: 'tinting-color',
                    title: 'Tinting Color',
                    type: 'item',
                    url: '/admin/master-data/tinting-color',
                    icon: icons.IconDatabase,
                    breadcrumbs: false,
                    allowedPermission: ['super']
                },
                {
                    id: 'tinting-group',
                    title: 'Tinting Group',
                    type: 'item',
                    url: '/admin/master-data/tinting-group',
                    icon: icons.IconDatabase,
                    breadcrumbs: false,
                    allowedPermission: ['super']
                },
                {
                    id: 'indeks',
                    title: 'Indeks',
                    type: 'item',
                    url: '/admin/master-data/indeks',
                    icon: icons.IconDatabase,
                    breadcrumbs: false,
                    allowedPermission: ['super']
                },
                {
                    id: 'lens-group',
                    title: 'Lens Group',
                    type: 'item',
                    url: '/admin/master-data/lens-group',
                    icon: icons.IconDatabase,
                    breadcrumbs: false,
                    allowedPermission: ['super']
                },
                {
                    id: 'lensa',
                    title: 'Lensa',
                    type: 'item',
                    url: '/admin/master-data/lensa',
                    icon: icons.IconDatabase,
                    breadcrumbs: false,
                    allowedPermission: ['super']
                }
            ]
        }
    ]
};

export default dashboard;
